import {call, all, put, select, takeEvery} from "redux-saga/effects"

import api from "../../services/ApiService"
import {
  KnowledgeArticlesCreators as Creators,
  KnowledgeArticlesTypes as Types
} from "./redux"
import {LangSwitchCreators as LangCreators} from "../../components/LangSwitch/redux"
import {AppCreators} from "../App/redux"
import {i18n, readableErrors, otherLanguages} from "../../utils"

export default function* router(dispatch, action) {
  const id = action.payload.params.id

  yield takeEvery(Types.KNOWLEDGE_ARTICLES_REQUEST, moreArticles, dispatch)
  yield takeEvery(
    Types.KNOWLEDGE_SUBCATEGORY_REQUEST,
    loadSubcategoryWithContent,
    dispatch
  )

  yield put(Creators.request(id, "", "order", "ASC"))
}

export function* moreArticles(_dispatch, {id, tag, sortby, orderby}) {
  let state = yield select()
  const lang = state.router.params.lang
  try {
    const [
      articlesResponse,
      sidebarResponse,
      tagsResponse,
      faqsidebarResponse
    ] = yield all([
      call(api.getKnowledgeArticlesBySort, id, tag, sortby, orderby, lang),
      call(api.getSidebar, lang),
      call(api.getKnowledgeTags, lang),
      call(api.getFAQSidebar, lang)
    ])

    yield put(
      Creators.success(
        articlesResponse.category,
        articlesResponse.subcategory,
        articlesResponse.posts,
        sidebarResponse,
        tagsResponse,
        faqsidebarResponse
      )
    )

    // refresh state
    state = yield select()

    // update language switch urls
    const otherLangs = Object.keys(otherLanguages(lang))
    if (otherLangs.length > 0) {
      // route shows subcategory
      if (
        state.knowledgearticles.subcategory.translations &&
        state.knowledgearticles.subcategory.translations[otherLangs[0]]
      ) {
        yield put(
          LangCreators.success(
            state.router.route
              .replace("/:lang/", `/${otherLangs[0]}/`)
              .replace(
                "/:id",
                `/${
                  state.knowledgearticles.subcategory.translations[
                    otherLangs[0]
                  ]
                }`
              )
          )
        )
      }
      // route shows category
      else if (
        state.knowledgearticles.category.translations &&
        state.knowledgearticles.category.translations[otherLangs[0]]
      ) {
        yield put(
          LangCreators.success(
            state.router.route
              .replace("/:lang/", `/${otherLangs[0]}/`)
              .replace(
                "/:id",
                `/${
                  state.knowledgearticles.category.translations[otherLangs[0]]
                }`
              )
          )
        )
      } else {
        yield put(LangCreators.success("null"))
      }
    }

    // tracking & title
    // ----
    // category
    if (Object.keys(articlesResponse.subcategory).length === 0) {
      yield put(
        AppCreators.trackingAdd({
          event: "mtm.virtualPageView",
          section: "knowledge",
          page_type: "category",
          category_name: articlesResponse.category.name,
          document_title: `${articlesResponse.category.name} | ${i18n.t(
            "Bibliothek"
          )}`
        })
      )

      // subcategory
    } else {
      yield put(
        AppCreators.trackingAdd({
          event: "mtm.virtualPageView",
          section: "knowledge",
          page_type: "subcategory",
          subcategory_name: articlesResponse.subcategory.name,
          category_name: articlesResponse.category.name,
          document_title: `${articlesResponse.subcategory.name} | ${
            articlesResponse.category.name
          } | ${i18n.t("Bibliothek")}`
        })
      )
    }
  } catch (e) {
    yield put(Creators.error(readableErrors(e)))
  }
}

export function* loadSubcategoryWithContent(_dispatch, {id}) {
  let state = yield select()
  const lang = state.app.lang
  try {
    const subcategoryWithContentResponse = yield call(
      api.getKnowledgeArticlesBySubcategoryWithContent,
      id,
      lang
    )
    yield put(
      Creators.subcategoryWithContentSuccess(subcategoryWithContentResponse)
    )
  } catch (e) {
    yield put(Creators.error(readableErrors(e)))
  }
}



// WEBPACK FOOTER //
// ./src/containers/KnowledgeArticles/sagas.js